export default "__VITE_ASSET__BHr1BTw4__"